import React from 'react';
import LandingPage from '../../pages/LandingPage';

const MainStack = (props) => {
    return (
        <LandingPage/>
    );
}

export default MainStack;